// Configuración de la moneda actual
window.shopCurrency = Shopify.currency.active;
window.currentCurrency = Shopify.currency.active;

// Asegurarse de que los precios se muestren en la moneda correcta
document.addEventListener('DOMContentLoaded', function() {
  if (window.shopCurrency !== window.currentCurrency) {
    updatePrices();
  }

  // Modificar para escuchar todos los selectores de moneda
  const currencySelectors = document.querySelectorAll('[data-currency-selector]');
  currencySelectors.forEach(selector => {
    selector.addEventListener('change', function(e) {
      e.preventDefault();
      window.currentCurrency = this.value;
      
      // Si el selector tiene el atributo data-form-submit, enviar el formulario
      if (this.hasAttribute('data-form-submit')) {
        const form = this.closest('form');
        if (form) {
          const scrollPosition = window.scrollY;
          const scrollInput = form.querySelector('[data-scroll-position]');
          if (scrollInput) {
            scrollInput.value = `${scrollInput.value}#scroll=${scrollPosition}`;
          }
          form.submit();
        }
      } else {
        // Solo actualizar precios sin recargar la página
        updatePrices();
      }
    });
  });
});

function updatePrices() {
  // Actualizar precios generales
  const priceElements = document.querySelectorAll('[data-price]');
  priceElements.forEach(element => {
    const originalPrice = element.getAttribute('data-original-price');
    if (originalPrice) {
      element.innerHTML = formatMoney(originalPrice);
    }
  });

  // Actualizar carrito si existe
  CartEvents.updateCart();
}

// Añadir método global para formatear precios
window.formatMoney = formatMoney;

function formatMoney(cents) {
  return (cents / 100).toLocaleString(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active,
    minimumFractionDigits: 2
  });
}